import { Injectable } from '@angular/core';
import { ProductCodeStore } from './product-code.store';
import { ApiService } from '../../shared/services/core/api.service';
import { ProductCode } from './product-code.model';
import { tap, mapTo } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ProductCodeService {
  constructor(private productCodeStore: ProductCodeStore, private api: ApiService) {}

  fetchProductCodes() {
    return this.api.get<ProductCode>('productcodes').pipe(
      tap(codes => this.productCodeStore.set(codes)),
      mapTo(null)
    );
  }
}
